class Helpers {
    constructor() {
        this.headingTagNames = ['H1', 'H2', 'H3', 'H4', 'H5', 'H6'];

        this.listTagnames = ['OL', 'UL'];
    }
    
    init() {
        return;
    }

    /**
     * (Accessible) Hide
     *
     * Hides an element and makes its
     * focusable elements unfocusable.
     * See also: (Accessible) Show
     *
     * @param {obj} element The element to
     *     hide
     */
     accessibleHide(element) {
        const focusableDescendants = element.querySelectorAll('a[href], area[href], input, select, textarea, button, iframe, object, embed, [tabindex], [contenteditable]');

        for (let item of focusableDescendants) {
            if(item.hasAttribute('tabindex')) {
                item.setAttribute('data-revert-tabindex-to', item.getAttribute('tabindex'));
            }

            item.setAttribute('tabindex', '-1');
        }

        element.style.setProperty('--display', window.getComputedStyle(element).getPropertyValue('display'));
        element.setAttribute('aria-hidden', 'true');
        element.hidden = true;

        return element;
    }

    /**
     * (Accessible) Show
     *
     * Unhides an element and makes its
     * focusable elements focusable again.
     * See also: (Accessible) Hide
     *
     * @param {obj} element The element to
     *     show
     */
    accessibleShow(element) {
        const focusableDescendants = element.querySelectorAll('[tabindex="-1"]');

        for (let item of focusableDescendants) {
            item.removeAttribute('tabindex');

            if (item.hasAttribute('data-revert-tabindex-to')) {
                item.setAttribute('tabindex', item.getAttribute('data-revert-tabindex-to'));

                item.removeAttribute('data-revert-tabindex-to');
            }
        }

        element.removeAttribute('aria-hidden');
        element.hidden = false;

        return element;
    }

    addExternalScript(url) {
        if (document.querySelector('body > script[src*="' + url + '"]')) {
            return;
        }

        const script = document.createElement('script'),
        firstBodyScript = document.querySelector('body > script');

        script.src = url;

        document.body.insertBefore(script, firstBodyScript);
    }

    changeHeadingLevels(element, startingHeadingLevel, newStartingHeadingLevel) {
        let difference = startingHeadingLevel - newStartingHeadingLevel,
            headings = element.querySelectorAll('h1, h2, h3, h4, h5, h6'),
            i;

        headings = [].slice.call(headings).sort((b, a) => a.tagName.localeCompare(b.tagName));

        for (let heading of headings) {
            let headingLevel = this.getHeadingLevel(heading),
            newHeadingLevel = headingLevel - difference;
            
            if (0 > newHeadingLevel) {
                continue;
            }
            
            if (6 < newHeadingLevel) {
                continue;
            }
            
            this.changeHTMLTag(heading, 'H' + newHeadingLevel);
        }

        return element;
    }

    /**
     * Change HTML Tag
     *
     * Change an element's tag name
     * while retaining its attributes,
     * attribute values, and its descendant
     * childNodes
     * @param {obj} element An HTML element
     * @param {string} tagName The target `tagName`
     */
    changeHTMLTag(element, tagName)
    {
        const parent = element.parentElement;
        const { attributes } = element;
        const newElement = document.createElement(tagName.toLowerCase());

        for (const attribute of attributes) {
            newElement.setAttribute(attribute.name, attribute.value);
        }

        while (element.childNodes.length) {
            newElement.appendChild(element.removeChild(element.childNodes[0]));
        }

        parent.replaceChild(newElement, element);

        return newElement;
    }

    areNodeListsEqual(list1, list2) {
        if (list1.length !== list2.length) {
            return false;
        }

        return Array.from(list1).every((node, index) => node === list2[index]);
    }

    createElementFromString(stringLiteral) {
        return document.createRange().createContextualFragment(stringLiteral);
    }

    createButton(textContent, attributes) {
        let button = document.createElement('button'),
            childNode = document.createTextNode(textContent);

        button.setAttribute('type', 'button');

        if (attributes) {
            for (const attribute in attributes) {
                button.setAttribute(attribute, attributes[attribute]);
            }
        }

        button.appendChild(childNode);

        return button;
    }

    getHeadingLevel(element) {
        if (!this.headingTagNames.includes(element.tagName)) return;

        return parseInt(element.tagName.substring(1));
    }

    isValidJSON(string) {   
        try {
            JSON.parse(string);
            return true;
        } catch (e) {
            return false;
        }
    }

    removeItemFromArray(array, item) {
        let index = array.indexOf(item);

        if (index > -1) {
            array.splice(index, 1);
        }
    }

    /**
     * Sanitize Title
     *
     * Convert a string into a 
     * WordPress -style "slug"
     * (suitable for use as an `id` value)
     * @param {string} string
     */
    sanitizeTitle(string)
    {
        // Based on https://gist.github.com/spyesx/561b1d65d4afb595f295
        string = string.replace(/^\s+|\s+$/g, ''); // trim
        string = string.toLowerCase();

        // remove accents, swap Ã± for n, etc
        var from = "Ã Ã¡Ã¤Ã¢Ã¨Ã©Ã«ÃªÃ¬Ã­Ã¯Ã®Ã²Ã³Ã¶Ã´Ã¹ÃºÃ¼Ã»Ã±Ã§Ä›Å¡ÄÅ™Å¾Ã½ÃºÅ¯ÄÅ¥ÅˆÂ·/_,:;";
        var to   = "aaaaeeeeiiiioooouuuuncescrzyuudtn------";

        for (var i = 0; i < from.length; i++)
        {
            string = string.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i));
        }

        string = string.replace('.', '-') // replace a dot by a dash 
            .replace(/[^a-z0-9 -]/g, '') // remove invalid chars
            .replace(/\s+/g, '-') // collapse whitespace and replace by a dash
            .replace(/-+/g, '-') // collapse dashes
            .replace( /\//g, '' ); // collapse all forward-slashes

        return string;
    }
}// end Class

// Singleton
export default Helpers;